<template>
    <div class="form-group" :class="{'input-group': hasIcon}">
        <slot name="label">
            <label v-if="label" class="control-label" :for="cusName">
                {{label}}
            </label>
        </slot>
        <slot name="addonLeft">
      <span v-if="addonLeftIcon" class="input-group-addon">
        <i :class="addonLeftIcon"></i>
      </span>
        </slot>
        <select
                @input="inputEvent('input',$event.target.value)"
                @blur="inputEvent('input',$event.target.value)"
                v-bind="$attrs"
                class="form-control"
                :class="{'is-invalid': hasErrors && hasErrors.has(cusName), 'is-valid': isInputValid()}"
                :id="cusName"
                :name="cusName"
                :value="value">
            <option v-for="(option, index) in list" :key="index" :value="option[selectedKey]">
                {{ option.name || option[showLabel] }}
            </option>
        </select>
        <slot></slot>
        <slot name="addonRight">
      <span v-if="addonRightIcon" class="input-group-addon">
        <i :class="addonRightIcon"></i>
      </span>
        </slot>
        <div v-show="hasErrors && hasErrors.has(cusName)" class="invalid-feedback">
            {{ hasErrors && hasErrors.first(cusName) }}
        </div>
    </div>
</template>
<script>
    export default {
        inheritAttrs: false,
        name: 'fg-select',
        props: {
            list:Array,
            hasErrors: {},
            isFields: {},
            cusName:String,
            selectedKey:String,
            showLabel:String,
            label: String,
            value: [String, Number, Boolean],
            addonRightIcon: String,
            addonLeftIcon: String
        },
        methods:{
            isInputValid(){
        var boolean = false;
        if(this.isFields && this.isFields[this.cusName]){
            boolean = this.isFields[this.cusName].valid;
        }
        return boolean;
    },
    inputEvent(name, value){
        this.isInputValid();
        this.$emit(name, value);
    }
    },
    computed: {
        hasIcon () {
            const {addonRight, addonLeft} = this.$slots;
            return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined
        }
    },
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/formGroupSelect.vue